exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ChangeUserGroup .v--modal-box.v--modal{min-height:350px!important;min-width:500px!important}#ChangeUserGroup .v-input__slot,#ChangeUserGroup .v-select__slot label,#ChangeUserGroup .v-text-field__slot label{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c6e8e66","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/userManagement/ChangeUserGroup.vue
// module id = 1977
// module chunks = 0